module.exports = __webpack_public_path__ + "static/img/1.0ccf01b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/1.png
// module id = 0Qdw
// module chunks = 0